import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "@studio-freight/lenis";

// Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Projects from "./components/Projects";
import Services from "./components/Services";
import Stats from "./components/Stats";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CustomCursor from "./components/CustomCursor";

// Project Pages
import YelpProject from "./components/projects/YelpProject";
import AdeeflyProject from "./components/projects/AdeeflyProject";
import FinTellProject from "./components/projects/FinTellProject";
import BareOrganicProject from "./components/projects/BareOrganicProject";
import CryptoDalalProject from "./components/projects/CryptoDalalProject";
import CardinalProject from "./components/projects/CardinalProject";

const Portfolio = () => {
  const lenisRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    // Initialize Lenis smooth scroll with optimized settings
    const lenis = new Lenis({
      duration: 1.0,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      infinite: false,
    });

    lenisRef.current = lenis;

    // Use a more efficient RAF loop
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }

    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle hash scroll when navigating back from project pages
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Projects />
        <Stats />
        <Services />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CustomCursor />
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/projects/yelp-mentorship-platform" element={<YelpProject />} />
          <Route path="/projects/adeefly" element={<AdeeflyProject />} />
          <Route path="/projects/fintell" element={<FinTellProject />} />
          <Route path="/projects/bare-organic" element={<BareOrganicProject />} />
          <Route path="/projects/cryptodalal" element={<CryptoDalalProject />} />
          <Route path="/projects/cardinal" element={<CardinalProject />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
